module.exports = __webpack_public_path__ + "static/media/close.e8799657.svg";